// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2UGVz","column":"style_column__3EyyL","row":"style_row__YOJaw"};